// src/ArrowBack.tsx
import { createIcon } from "@chakra-ui/icon";
var ArrowBackIcon = createIcon({
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
  displayName: "ArrowBackIcon"
});

export {
  ArrowBackIcon
};
